import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/Toast"
import { useToast } from "@/hooks/use-toast"
import { CopyableTraceId } from "@/components/ui/CopyableTraceId"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, buttons, traceId, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {traceId && <CopyableTraceId traceId={traceId} />}
              {action && (
                <div className="flex items-center gap-2">
                  {action}
                </div>
              )}
              {buttons && buttons.length > 0 && (
                <div className="flex items-center gap-2">
                  {buttons.map((button, index) => {
                    const isPrimary = button.variant === 'primary'
                    const handleClick = () => {
                      if (button.onClick) {
                        button.onClick()
                      }
                      if (button.href) {
                        // Use window.location for navigation to avoid Router context issues
                        window.location.href = button.href
                      }
                    }

                    return (
                      <button
                        key={index}
                        onClick={handleClick}
                        className={
                          isPrimary
                            ? "inline-flex h-9 shrink-0 items-center justify-center rounded-sm bg-gray-900 px-4 text-sm font-medium text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
                            : "inline-flex h-9 shrink-0 items-center justify-center rounded-sm border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
                        }
                      >
                        {button.label}
                      </button>
                    )
                  })}
                </div>
              )}
            </div>
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}